import { TraitRegistryAspectHtml } from './TraitRegistryAspectHtmlTag';
import { TraitRegistryCategory } from '../TraitRegistryCategory';
import { TraitRegistryAspectExportImport } from './traits/TraitRegistryAspectExportImport';
import { TraitRegistryAspectContent } from './TraitRegistryAspectContent';
import { TraitRegistryAspectStructure } from './TraitRegistryAspectStructure';
import { TraitRegistryAspectDraggable } from './TraitRegistryAspectDraggable';
export class TraitRegistryAspect extends TraitRegistryCategory {
    label = 'Aspect';
    c_h = new TraitRegistryAspectHtml(this);
    c_e = new TraitRegistryAspectExportImport(this);
    c_c = new TraitRegistryAspectContent(this);
    c_s = new TraitRegistryAspectStructure(this);
    c_d = new TraitRegistryAspectDraggable(this);
}
